<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      title="编辑部门"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="部门名称">
          <a-input
            v-decorator="['name', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入部门名称' },
                { max: 50, message: '最多50个字符' }
              ]
            }]"
          />
        </a-form-item>
        <a-form-item label="主管">
          <a-select
            show-search
            option-filter-prop="children"
            :filter-option="filterOption"
            v-decorator="['manager_user_id']"
          >
            <a-select-option :value="0">暂不设置</a-select-option>
            <a-select-option
              v-for="member in members"
              :key="member.id"
              :value="member.id"
            >
              {{ member.full_name }}（{{ member.role_name }}）
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findDepartmentForm, updateDepartment } from '@/api/department'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'department' }),
      submitting: false,
      members: []
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchFormData()
  },
  methods: {
    fetchFormData() {
      findDepartmentForm(this.id).then((res) => {
        if (res.code === 0) {
          this.members = res.data.members || []
          this.$nextTick(() => {
            this.form.setFieldsValue({
              name: res.data.name,
              manager_user_id: res.data.manager_user_id || 0
            })
          })
        }
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          updateDepartment(this.id, values).then((res) => {
            if (res.code === 0) {
              this.isShow = false
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
